module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-slide-filelist"
  }, [_c('rt-section', {
    attrs: {
      "title": _vm.title,
      "icon": _vm.titleIcon
    }
  }, [_vm._t("right-top", function() {
    return [(_vm.showButtons) ? _c('el-upload', {
      staticClass: "addBtn",
      attrs: {
        "slot": "btn",
        "show-file-list": false,
        "http-request": _vm.uploadFile,
        "action": ""
      },
      slot: "btn"
    }, [_c('rt-button', {
      attrs: {
        "icon-name": "rt-base-plus",
        "color-type": _vm.iconColor
      }
    })], 1) : _vm._e()]
  }, {
    "slot": "btn"
  }), _vm._v(" "), (_vm.data.length > 0) ? _c('div', {
    staticClass: "file-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "file-item"
    }, [_c('div', {
      staticClass: "file-icon"
    }, [(_vm.isImage(item.name)) ? _c('rt-popover', {
      attrs: {
        "popper-class": "rt-upload-slide-image",
        "placement": "left",
        "trigger": "hover"
      }
    }, [(_vm.isImage(item.name)) ? _c('rt-image-preview', {
      attrs: {
        "src": item.url,
        "preview-src-list": [item.url]
      }
    }) : _c('rt-icon', {
      attrs: {
        "name": _vm.fileIconName(item.name),
        "color": _vm.fileIconName(item.name),
        "size": "32"
      }
    }), _vm._v(" "), (_vm.isImage(item.name)) ? _c('rt-image-preview', {
      staticStyle: {
        "width": "40px",
        "height": "40px"
      },
      attrs: {
        "slot": "reference",
        "src": item.url,
        "preview-src-list": [item.url]
      },
      slot: "reference"
    }) : _c('rt-icon', {
      attrs: {
        "slot": "reference",
        "name": _vm.fileIconName(item.name),
        "color": _vm.fileIconName(item.name),
        "size": "32"
      },
      slot: "reference"
    })], 1) : _c('rt-icon', {
      attrs: {
        "name": _vm.fileIconName(item.name),
        "color": _vm.fileIconColor(item.name),
        "size": "32"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "file-detail"
    }, [_c('p', {
      staticClass: "item-name",
      on: {
        "click": function($event) {
          return _vm.itemClick(index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), (item.size) ? _c('div', {
      staticClass: "item-size"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$tx('大小：', 'xpc.uploadfile.size')))]), _vm._v(_vm._s(_vm.fileSize(item.size)) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "uploadTime-and-operation"
    }, [_c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.uploadTime))]), _vm._v(" "), _c('div', {
      staticClass: "operation"
    }, [(_vm.showDownload) ? _c('rt-button', {
      attrs: {
        "text": "",
        "type": "plain"
      },
      on: {
        "click": function($event) {
          return _vm.downloadClick(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$tx('下载', 'xpc.uploadfile.download')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.showDelete) ? _c('rt-popconfirm', {
      attrs: {
        "title": _vm.$tx(
          '确定需要删除这条内容吗？',
          'xpc.uploadfile.confirmdelete'
        )
      },
      on: {
        "confirm": function($event) {
          return _vm.onConfirm(item.name, index)
        }
      }
    }, [_c('rt-button', {
      attrs: {
        "slot": "reference",
        "text": "",
        "type": "plain"
      },
      slot: "reference"
    }, [_vm._v("\n                  " + _vm._s(_vm.$tx('删除', 'xpc.uploadfile.delete')) + "\n                ")])], 1) : _vm._e()], 1)])])])
  }), 0) : _vm._t("empty", function() {
    return [_c('rt-default-image', [_c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_vm._v("\n          " + _vm._s(_vm.$tx('暂无数据', 'xpc.uploadfile.nodata')) + "\n        ")])])]
  })], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.imgVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.imgVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.previewUrl
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5a31e72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/uploadSlideFilelist/rtUploadSlideFile.vue
// module id = 2236
// module chunks = 137